module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Daniel Hiebert.a3cd1141.pdf";